$( document ).ready(function() {

  const $ankers = $('a[href^="#"]');


  $ankers.on('click', scrollIntoView);


  function scrollIntoView(e) {
    const href = $(this).attr('href');
    const $target = $(href);

    if ($target.length) {
      e.preventDefault();
      $target.get(0).scrollIntoView({"behavior": "smooth", block: "start", inline: "nearest"})
    }
  }

});
